export const pickCountryModalStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		p: 2,
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%'
	},

	title: {
		mb: 1.5
	}
};
